import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'popup-modal',
    templateUrl: './popup-modal.component.html'
})
export class PopUpModalComponent implements OnInit {

    @Input() message: string = '';
    @Input() title: string = '';

    constructor(private activeModal: NgbActiveModal) { }

    ngOnInit() {
    }
    cancel() {
        this.activeModal.dismiss();
    }
}
